<template>
	<div>
		<Modal v-on:close="$emit('close')">
			<Loader v-if="loading" />
			<template v-else>
				<div class="input-row small-margin-bottom">
					<span class="label">Reschedule to</span>
					<input type="text" v-model="record.call_at" />
				</div>
				<button v-on:click="confirm()" :disabled="saving">Confirm</button>
			</template>
		</Modal>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    saving: false,
    record: {}
  }),
  methods: {
    load () {
      Vue.$api.get('/scheduled-call/' + this.id, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.record = data
      })
    },
    confirm () {
      Vue.$api.patch('/scheduled-call/' + this.id + '/reschedule', {
        datetime: this.record.call_at
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.success()
      })
    },
    success () {
      this.$emit('success')
    }
  },
  created () {
    this.load()
  }
}
</script>
